module.exports = __webpack_public_path__ + "assets_1773901505253/img/logo.71acd534.png";